import type { DeepReadonly } from 'deep-freeze';
import type { State } from 'redux/modules/messages.types';
import { closeMessage } from 'redux/modules/messages.types';
import { reducerWithInitialState } from 'typescript-fsa-reducers';

export const initialState: State = {
  closed: false,
};

const reducer = reducerWithInitialState<DeepReadonly<State>>(initialState).case(
  closeMessage,
  state => {
    return {
      ...state,
      closed: true,
    };
  }
);

export default reducer;
